import { isValidFipsCode, isValidMedicalPlanId, isValidMemberId, isValidZipCode } from 'utils'
import { useGetAdminMedicalPlans } from 'utils/web_api'
import type { GetAdminMedicalPlansParams } from 'utils/web_api.schemas'

import { MEDICAL_PLAN_CACHE, MEDICAL_PLAN_PAGINATION } from '../constants'
import { type MedicalPlanFilters } from './useMedicalPlanFilters'

export function useMedicalPlans (filters: MedicalPlanFilters) {
  const params: GetAdminMedicalPlansParams = {
    'page[number]': filters.page || MEDICAL_PLAN_PAGINATION.DEFAULT_PAGE_NUMBER,
    'page[size]': filters.perPage || MEDICAL_PLAN_PAGINATION.DEFAULT_PAGE_SIZE,
    'filters[year]': filters.year || '', // Year is required by the API
  }

  // Add filter parameters as flat keys (matching the schema)
  if (filters.state) params['filters[state]'] = filters.state
  // Only include zip code in API request if it's valid (5 digits)
  if (filters.zipCode && isValidZipCode(filters.zipCode)) {
    params['filters[zip_code]'] = filters.zipCode
  }
  // Only include FIPS county code in API request if it's valid (5 digits)
  if (filters.fipsCountyCode && isValidFipsCode(filters.fipsCountyCode)) {
    params['filters[fips_county_code]'] = filters.fipsCountyCode
  }
  // Only include member ID in API request if it's valid (starts with "mbr_" and is 30 chars)
  if (filters.memberId && isValidMemberId(filters.memberId)) {
    params['filters[member_id]'] = filters.memberId
  }
  if (filters.hiosId) params['filters[hios_id]'] = filters.hiosId
  // Only include medical plan ID in API request if it's valid (starts with "mdpln_")
  if (filters.medicalPlanId && isValidMedicalPlanId(filters.medicalPlanId)) {
    params['filters[medical_plan_id]'] = filters.medicalPlanId
  }
  if (filters.offMarketOnly !== undefined) params['filters[off_market_only]'] = filters.offMarketOnly
  if (filters.activelyMarketedOnly !== undefined) params['filters[actively_marketed_only]'] = filters.activelyMarketedOnly
  if (filters.carrierNames && filters.carrierNames.length > 0) params['filters[carrier_names][]'] = filters.carrierNames
  if (filters.metalTiers && filters.metalTiers.length > 0) params['filters[metal_tiers][]'] = filters.metalTiers
  if (filters.planTypes && filters.planTypes.length > 0) params['filters[plan_types][]'] = filters.planTypes
  if (filters.hsaEligible !== undefined) params['filters[hsa_eligible]'] = filters.hsaEligible

  return useGetAdminMedicalPlans(params, {
    query: {
      staleTime: MEDICAL_PLAN_CACHE.STALE_TIME_MS,
    },
  })
}
